const attachment = {
  id: '544f947c-390b-4200-b599-d60b3a5bdabc',
  contentType: 'application/vnd.microsoft.card.adaptive',
  name: null,
  thumbnailUrl: null,
  contentUrl: null,
  content: JSON.stringify({
    type: 'AdaptiveCard',
    $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
    version: '1.4',
    body: [
      {
        type: 'ColumnSet',
        columns: [
          {
            type: 'Column',
            width: 2,
            items: [
              {
                type: 'TextBlock',
                text: '{{COLLECTIVE_GOAL_ICON}} {{COLLECTIVE_GOAL_HEADLINE}}',
                wrap: true,
                fontType: 'Default',
                size: 'Medium',
                weight: 'Bolder'
              },
              {
                type: 'ColumnSet',
                columns: [
                  {
                    type: 'Column',
                    width: '60px',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{COLLECTIVE_GOAL_PROGRESS}}',
                        weight: 'Bolder',
                        size: 'ExtraLarge',
                        spacing: 'Large',
                        height: 'stretch',
                        wrap: true,
                        maxLines: 0
                      }
                    ],
                    spacing: 'None'
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '{{COLLECTIVE_GOAL_FIRST_LINE}}',
                        wrap: true,
                        weight: 'Bolder'
                      },
                      {
                        type: 'TextBlock',
                        text: '{{COLLECTIVE_GOAL_SECOND_LINE}}',
                        wrap: true,
                        spacing: 'None'
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        type: 'ColumnSet',
        columns: [
          {
            type: 'Column',
            width: 2,
            items: [
              {
                type: 'ColumnSet',
                columns: [
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🟩',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🟩',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🟩',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🟩',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🟩',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🟩',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '🟩',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '⬜️',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '⬜️',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '⬜️',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '⬜️',
                        wrap: true
                      }
                    ]
                  },
                  {
                    type: 'Column',
                    width: 'stretch',
                    items: [
                      {
                        type: 'TextBlock',
                        text: '⬜️',
                        wrap: true
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  })
};

export default {
  id: 'teams_collective_goal',
  title: 'Collective goal',
  type: 'Direct / Channel',
  canSendToChannel: true,
  description: 'Current status of the collective goal.',
  body: {
    attachments: [ attachment ],
    body: {
      contentType: 'html',
      content: `
      <div>
        <p>[[INPUT_INTRODUCTION_TEXT]]</p>
        <attachment id='${attachment.id}'></attachment>
        <p>[[INPUT_END_TEXT]]</p>
      </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
    },
  },
  inputs: {
    INPUT_INTRODUCTION_TEXT: {
      label: 'Intro',
      placeholder: 'Hi all, ...',
      defaultValue: '<p>Hi all,</p><p>Please find the current status of our collective goal below.</p>',
      type: 'HTML'
    },
    INPUT_END_TEXT: {
      label: 'Text after collective goal',
      type: 'HTML',
      placeholder: 'Thanks for your support!',
      defaultValue: '<p>Do not forget that every activity on the platform gets us closer to reach our goal together.</p><p>If you have any questions please let me know.</p>',
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/applus/collectiveGoal.js